import { gradients } from '@gto/ui/theme/design-tokens'

import { zIndex } from '@/utils/constants'

export const UnderlyingBackground = () => {
  return (
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        background: gradients.primary.horizontal(0.000001, 0.06),
        zIndex: zIndex.underlyingBg,
      }}
    />
  )
}
